import script from "./PreviewFallbackToolsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewFallbackToolsCard.vue?vue&type=script&setup=true&lang=js"

import "./PreviewFallbackToolsCard.vue?vue&type=style&index=0&id=2f029f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f029f46"]])

export default __exports__